import './App.css';
import Header from './components/Header';
import Content from './components/Content';
import Event from './components/Event';

function App() {
  return (
    <div className="App">
      <Header/>
      <Content/>
      <Event/>
    </div>
  );
}

export default App;
